import _slicedToArray from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-LOS-UI-Release-prod-6/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-LOS-UI-Release-prod-6/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-LOS-UI-Release-prod-6/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import NoSsr from "@material-ui/core/NoSsr";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Popper from "@material-ui/core/Popper";
import Paper from "@material-ui/core/Paper";
export const nullify = () => null;
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    minWidth: 290
  },
  input: {
    display: 'flex',
    padding: 0,
    height: 'auto'
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden'
  },
  noOptionsMessage: {
    padding: theme.spacing(1, 2)
  },
  singleValue: {
    fontSize: 14
  },
  paper: {
    position: 'absolute',
    backgroundColor: '#fff',
    zIndex: 2001,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
    width: '570px',
    height: 'auto'
  },
  divider: {
    height: theme.spacing(2)
  }
}));
function NoOptionsMessage(props) {
  return /*#__PURE__*/React.createElement(Typography, Object.assign({
    color: "textSecondary",
    className: props.selectProps.classes.noOptionsMessage
  }, props.innerProps), props.children);
}
function inputComponent(_ref) {
  let inputRef = _ref.inputRef,
    props = _objectWithoutProperties(_ref, ["inputRef"]);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    ref: inputRef
  }, props));
}
function Control(props) {
  const _props$selectProps = props.selectProps,
    validate = _props$selectProps.validate,
    name = _props$selectProps.name,
    classes = _props$selectProps.classes,
    textFieldProps = _props$selectProps.textFieldProps;
  const children = props.children,
    innerProps = props.innerProps,
    innerRef = props.innerRef;
  return /*#__PURE__*/React.createElement(TextField, Object.assign({
    fullWidth: true,
    InputProps: {
      inputComponent,
      inputProps: _objectSpread({
        'data-testid': 'smart-dropdown-input',
        name: name,
        className: classes.input,
        ref: innerRef,
        children
      }, innerProps)
    }
  }, textFieldProps));
}
function Option(props) {
  return /*#__PURE__*/React.createElement(MenuItem, Object.assign({
    classes: {
      root: props.selectProps.classes.menuItem
    },
    buttonRef: props.innerRef,
    selected: props.isFocused,
    component: "div",
    style: {
      fontWeight: props.isSelected ? 500 : 400
    }
  }, props.innerProps), props.children);
}
function SingleValue(props) {
  return /*#__PURE__*/React.createElement(Typography, Object.assign({
    className: props.selectProps.classes.typography
  }, props.innerProps), props.children);
}
function ValueContainer(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.selectProps.classes.valueContainer
  }, props.children);
}
function Menu(props) {
  return /*#__PURE__*/React.createElement(Popper, Object.assign({
    open: !Boolean(props.hide),
    anchorEl: props.selectProps.inputNode.current,
    className: props.selectProps.classes.paper
  }, props.innerProps, {
    modifiers: {
      preventOverflow: {
        enabled: true,
        boundariesElement: "scrollParent"
      },
      hide: {
        enabled: false
      }
    }
  }), /*#__PURE__*/React.createElement(Paper, Object.assign({}, props.innerProps, {
    "data-testid": "smart-dropdown-menu"
  }), props.children));
}
const components = {
  Control,
  Menu,
  NoOptionsMessage,
  Option,
  SingleValue,
  ValueContainer
};
const SmartDropdown = props => {
  const classes = useStyles();
  const theme = useTheme();
  const _React$useState = React.useState(props.optionValue),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    single = _React$useState2[0],
    setSingle = _React$useState2[1];
  const inputNode = React.createRef();
  const handleOptionValueChange = single => {
    if (props.optionValue !== single) setSingle(props.optionValue);
  };
  useEffect(() => {
    handleOptionValueChange(single);
  }, [single]);
  const changeValue = e => {
    console.log(e);
    setSingle(e.value);
    if (e.value !== props.value) {
      props.onChange(e.value);
    }
  };
  const blurValue = e => {
    if (e.currentTarget.defaultValue && e.currentTarget.defaultValue !== props.value) {
      setSingle(e.currentTarget.defaultValue);
      props.onBlur(e.currentTarget.defaultValue);
    }
  };
  const determineIndex = (options, choice) => {
    let index = -1;
    options.forEach((option, i) => {
      if (option.value === choice) {
        index = i;
      }
    });
    return index;
  };
  const selectStyles = {
    input: base => _objectSpread({}, base, {
      color: theme.palette.text.primary,
      "& input": {
        font: "inherit"
      }
    })
  };
  const newOptions = props.options.map(option => ({
    value: option.value,
    label: option.text
  }));
  const index = determineIndex(newOptions, single);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root,
    ref: inputNode,
    "data-testid": "smart-dropdown",
    id: props.id
  }, /*#__PURE__*/React.createElement(NoSsr, null, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Select, {
    classes: classes,
    styles: _objectSpread({}, selectStyles),
    inputId: "smart-dropdown-".concat(props.name),
    autoFocus: false,
    options: newOptions,
    components: components,
    value: single,
    onChange: changeValue,
    onBlur: blurValue,
    inputNode: inputNode,
    openMenuOnFocus: false,
    name: props.name,
    validate: props.validate,
    placeholder: props.placeholder,
    textFieldProps: {
      label: props.name,
      placeholder: props.placeholder,
      InputLabelProps: {
        shrink: true,
        htmlFor: "smart-dropdown-".concat(props.name)
      }
    }
  }))));
};
SmartDropdown.defaultProps = {
  id: "smart-dropdown",
  options: [],
  name: "",
  onChange: nullify,
  onBlur: nullify,
  validate: false,
  hide: false,
  placeholder: "",
  value: {
    label: "",
    value: ""
  }
};
export default SmartDropdown;